<template>
    <aside class="remodal">
        <button data-remodal-action="close" class="remodal-close">
            <i class="material-icons">close</i>
        </button>
        <slot name="body">
            <div class="btn btn--white btn--wrapper text--center mb--md">
                <img :src="icon" alt="" />
            </div>

            <h4 class="modal__title"><slot name="title">Done</slot></h4>

            <div class="mb--30">
                <p><slot name="message"></slot></p>
            </div>
        </slot>

        <slot name="buttons">
            <a href="#" @click.prevent="handleClose" class="btn btn--block btn--secondary">Go to dashboard</a>
        </slot>

    </aside>
</template>

<script>
    export default {
        props: {
            type: {
                required: false,
                default: 'success'
            },

            show: {
                required: false,
                default: true
            },

            headerIcon: {
                required: false,
                default: null
            }
        },

        data: () => ({
            instance: null
        }),

        mounted() {
            this.instance = $(this.$el).remodal({
                hashTracking: false
            });

            if (this.show === true) {
                this.instance.open()
            }
        },

        methods: {
            close() {
                this.instance.close()
            },

            open() {
                this.instance.open()
            },

            handleClose() {
                this.close()

                if (this.$router.currentRoute.path  !== '/') {
                    this.$router.push('/')
                }
            }
        },

        computed: {
            icon() {
                if (this.headerIcon) {
                    return this.headerIcon
                }

                return '/img/icons/' + this.type + '.svg'
            }
        }
    }
</script>
